// src/lib/email.js
// Calls the /api/send-email serverless function
// Never blocks order placement — runs silently in background

const API_URL = "/api/send-email";

export async function sendOrderConfirmation(order) {
  try {
    const res = await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type: "order_placed", order }),
    });
    const data = await res.json();
    if (!res.ok) {
      console.warn("Email API:", data.error);
      return { success: false, error: data.error };
    }
    return { success: true };
  } catch (err) {
    // Never throw — email failure should NOT block order placement
    console.warn("Email send failed (non-critical):", err.message);
    return { success: false, error: err.message };
  }
}

export async function sendStatusUpdate(order, newStatus) {
  try {
    const res = await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type: "status_update", order, newStatus }),
    });
    const data = await res.json();
    if (!res.ok) {
      console.warn("Status email:", data.error);
      return { success: false, error: data.error };
    }
    return { success: true };
  } catch (err) {
    console.warn("Status email failed (non-critical):", err.message);
    return { success: false, error: err.message };
  }
}
